import { render, staticRenderFns } from "./tabkj.vue?vue&type=template&id=65805251&scoped=true&"
import script from "./tabkj.vue?vue&type=script&lang=js&"
export * from "./tabkj.vue?vue&type=script&lang=js&"
import style0 from "./tabkj.vue?vue&type=style&index=0&id=65805251&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65805251",
  null
  
)

export default component.exports